module.exports = __webpack_public_path__ + "averyWePrintLogo.334ef4dbbea1b0264602.png";


//////////////////
// WEBPACK FOOTER
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/assets/img/averyWePrintLogo.png
// module id = ../../../../../src/assets/img/averyWePrintLogo.png
// module chunks = styles